import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import { App } from './App';
import './i18n';
import './styles/global.css';

// After a deploy, a tab opened before it still references the old hashed
// chunks; loading one of its lazy routes then fails. Reload to pick up the new
// build, at most once a minute so a chunk that is really missing surfaces as
// an error instead of a reload loop.
window.addEventListener('vite:preloadError', (event) => {
  try {
    const last = Number(sessionStorage.getItem('ssp_chunk_reload_at') || 0);
    if (Date.now() - last < 60_000) return;
    sessionStorage.setItem('ssp_chunk_reload_at', String(Date.now()));
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
